










import { Component, Vue, Watch } from 'vue-property-decorator';
import { mapGetters } from 'vuex';

import { StatsService } from '@/platform/services/stats.service';

import { FILTERS_GETTER_TYPES } from '@/platform/store/filters/filters.getter.types';

import { StatsReportsIdsEnum } from '@empathybroker/tsclient-stats/dist/enums/stats-reports-ids.enum';
import { TermSuccessReportResponse } from '@empathybroker/tsclient-stats/dist/models/termsuccessreport/termsuccessreport-response';

import { SearchSuccessDataRow, SearchSuccessViz, SearchSuccessVizOption } from '@empathybroker/search-success-viz';

@Component({
  computed: {
    ...mapGetters({
      filtersSelectedValues: FILTERS_GETTER_TYPES.selectedValues,
      filtersAreValid: FILTERS_GETTER_TYPES.areValid
    })
  }
})
export default class SearchSuccessWrapperComponent extends Vue {

  private filtersAreValid: boolean;

  private searchQuery = '';

  private visualization: SearchSuccessViz;

  private topQueries: SearchSuccessDataRow[];
  private vizOptions: SearchSuccessVizOption = {
    searchStringName: 'queries'
  };

  private fromSearch: boolean;

  @Watch('filtersSelectedValues', { deep: true })
  private onFiltersSelectedValuesChange(): void {
    this.fetchData();
  }

  private mounted(): void {
    this.visualization = new SearchSuccessViz(this.$refs.searchSuccessContainer, this.vizOptions);

    this.fetchData();
  }

  private fetchData(): void {
    if (!this.filtersAreValid) {
      return;
    }

    this.showLoadingMask();

    this.searchQuery = '';
    this.fromSearch = false;

    this.getTermSuccessData();
  }

  private onSearchChange(searchTerm: string): void {
    this.showLoadingMask();

    if (!searchTerm) {
      this.fromSearch = false;
      this.visualization.setData(this.topQueries, this.fromSearch);

      this.hideLoadingMask();
    } else {
      this.fromSearch = true;

      this.getTermSuccessData(searchTerm);
    }
  }

  private getTermSuccessData(terms?: string): void {
    StatsService.getStatsReport(StatsReportsIdsEnum.TERM_SUCCESS, {
      rows: (this.fromSearch) ? 30 : 10,
      terms: terms
    }).then((response: TermSuccessReportResponse) => {
      if (!this.fromSearch) {
        this.topQueries = this.decodeTermSuccessResponseData(response);
        this.visualization.setData(this.topQueries, this.fromSearch);
      } else {
        const searchQueries = this.decodeTermSuccessResponseData(response);
        this.visualization.setData(searchQueries, this.fromSearch);
      }
      this.hideLoadingMask();
    }).catch(() => this.handlerErrors());
  }

  private decodeTermSuccessResponseData(termSuccessResponse: TermSuccessReportResponse): SearchSuccessDataRow[] {
    return termSuccessResponse.data.map(term => {
      return {
        searchString: term.terms,
        query_count: term.queryCount,
        no_results: term.queryCountNoResults,
        clicks: term.clickCount,
        success_clicks: term.successCount,
        add_to_cart: term.add2cartCount,
        no_clicks: term.queryCount - term.clickCount
      };
    });
  }

  private showLoadingMask(): void {
    this.$emit('update:loading', true);
  }

  private hideLoadingMask(): void {
    this.$emit('update:loading', false);
  }

  private handlerErrors(): void {
    this.$emit('update:loading', false);
  }
}




// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/insights/components/catalog/searchsuccess/searchsuccess-wrapper.component.vue